(function addToteToGarmentCatalogue() {
  const catalogue = window.SNF_GARMENT_CATALOG;
  if (!Array.isArray(catalogue) || catalogue.some((style) => style.id === 'qtees-qtb')) return;
  const colours = [
    ['White', '#FFFFFF'], ['Black', '#222326'], ['Carolina Blue', '#799FBD'],
    ['Charcoal', '#4F5052'], ['Forest', '#244638'], ['Gold', '#ECAA22'],
    ['Grey', '#A8A49A'], ['Hot Pink', '#DB377D'], ['Kelly', '#218858'],
    ['Lavender', '#B5A3CE'], ['Light Pink', '#F1C4D4'], ['Natural', '#E4D6B7'],
    ['Navy', '#222B45'], ['Orange', '#E46025'], ['Purple', '#5B3F77'],
    ['Red', '#AF263E'], ['Royal', '#365797'], ['Sapphire', '#197D9D'],
    ['Turquoise', '#48A8B4'], ['Yellow', '#F4D54A']
  ];
  catalogue.push({
    id: 'qtees-qtb',
    category: 'totes',
    audience: 'unisex',
    code: 'QTB',
    label: 'Cotton Tote Bag',
    title: 'Q-Tees QTB Cotton Tote Bag',
    supplierPdf: 'https://en-ca.ssactivewear.com/ShopNow/ItemSpecSheet.aspx?ID=3779&ColorID=44953&LanguageCode=en',
    officialPage: 'https://en-ca.ssactivewear.com/p/q_tees/qtb?color=white-q-tees_qtb',
    prices: { 'One Size': 1699 },
    pricePending: false,
    colours: colours.map(([name, hex]) => ({ name, hex, sizes: ['One Size'] }))
  });
})();
